<script>
import VueCropper from 'vue-cropperjs';
import FileUpload from 'vue-upload-component';
import 'cropperjs/dist/cropper.css';

export default {
  name: 'SingleImageCrop',
  components: {
    VueCropper,
    FileUpload,
  },
  props: {
    // eslint-disable-next-line
    value: {},
    // eslint-disable-next-line
    metaData: {},
    // eslint-disable-next-line
    init: {
      default: false,
    },
    clearButtonContainer: {
      type: String,
      default: '',
    },
    clearButton: {
      type: String,
      default: '',
    },
    dropzoneClass: {
      type: String,
      default: 'fileUploadZone',
    },
    imageResizeHeight: {
      type: String,
      default: '300px',
    },
    aspectRatio: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      initialImage: null,
      files: [],
      edit: false,
      uniqueRef: crypto.randomUUID(),
    };
  },
  watch: {
    'files': function (val) {
      this.$nextTick(() => {
        const entity = Array.isArray(val) ? val[0].file : val;
        if(entity instanceof File) {
          this.selectFile(entity);
        }
      });
    },
    value(val) {
      if (val && !(val instanceof File)) {
        this.edit = true;
        this.initialImage = val;
      }
    },
  },
  mounted() {
    if (this.init && this.value && !(this.value instanceof File)) {
      this.edit = true;
      this.initialImage = this.value;
    }
  },
  methods: {
    selectFile(file) {
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.initialImage = event.target.result;
          this.edit = true;
          this.$emit('input', file);
        };
        reader.readAsDataURL(file);
      } else {
        this.$emit('input', null);
      }
    },
    clear() {
      if (this.files.length) {
        this.$refs[`uploadImage${this.uniqueRef}`].clear();
      } else {
        this.edit = false;
        this.initialImage = null;
        this.$emit('input', null);
      }
    },
    getData() {
      this.$nextTick(() => {
        this.$emit('meta-update', this.$refs[this.uniqueRef].getData(true));
      });
    },
  },
};
</script>

<template>
  <div>
    <div v-show="!edit">
      <div>
        <FileUpload
          :ref="`uploadImage${uniqueRef}`"
          v-model="files"
          extensions="gif,jpg,jpeg,png"
          accept="image/png,image/gif,image/jpeg"
          name="image"
          :class="$style[dropzoneClass]"
          post-action="/upload/post"
          :input-id="`${uniqueRef}`"
          :drop="!edit"
        >
          Drag an image or click here to select a file
        </FileUpload>
      </div>
    </div>
    <div v-if="initialImage">
      <VueCropper
        :ref="uniqueRef"
        :src="initialImage"
        drag-mode="crop"
        :aspect-ratio="aspectRatio"
        :auto-crop-area="0.5"
        :cropend="getData"
        :zoom="getData"
        :img-style="{ width: 'auto', height: imageResizeHeight }"
      >
      </VueCropper>
      <div class="text-center p-4" :class="clearButtonContainer">
        <button type="button" class="btn btn-secondary" :class="clearButton" @click.prevent="clear">Clear</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.dropActive {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  text-align: center;
  background: #000;
  opacity: 0.6;
}
.dropActive h3 {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  padding: 0;
  margin: -0.5em 0 0;
  font-size: 40px;
  color: #fff;
  transform: translateY(-50%);
}
.fileUploadZoneSmall {
  height: 155px;
}

.fileUploadZone {
  height: 200px;
}

.fileUploadZone,
.fileUploadZoneSmall {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 1.5rem;
  cursor: pointer;
  background-color: #eee;
  border: 3px dashed grey;
  &:hover {
    border-color: #1a87a7;
  }
}
</style>
